// 中文语言包
/**
 * common 公共的内容
 * router 路由用到
 * components 公用组件的内容
 * tableColumn
 * form 表单相关标签/placeholder/options
 * formRules 规则
 * msg
 * error
 * fields 监测属性
 * units 单位
 * dync 动态参数集合
 *...其他也面用到的翻译
 */
module.exports = {
  // 公共的内容
  common: {
    enable: '启用',
    notEnabled: '未启用',
    allSelect: '全部选中',
    cancelSelect: '全选取消',
    selectAll: '全选',
    passwordAgainPlacecholder: '请再次输入密码',
    selectProject: '选择项目',
    signOut: '退出登录',
    loading: '加载中',
    reset: '重置',
    next: '下一步',
    submit: '提 交',
    total: '总数',
    corporation: '企业',
    project: '项目',
    structure: '结构物',
    subsidiary: '子公司',
    measuringPoint: '测点',
    device: '设备',
    measurement: '监测类型',
    deviceType1: '设备类别',
    search: '查询',
    rtLink: '实时数据连接',
    chartLoading: '正在生成图表',
    exportData: '导出数据',
    exportReport: '导出报表',
    pleaseSelect: '请选择',
    pleaseInput: '请输入',
    all: '全部',
    seeDetails: '查看详情',
    delete: '删除',
    deleteConfig: '删除配置',
    cancel: '取消',
    longitude: '经度',
    latitude: '纬度',
    altitude: '高程',
    offsetE: '东向偏移量（单位：米）',
    offsetN: '北向偏移量（单位：米）',
    offsetU: '天向偏移量（单位：米）',
    offsetTime: '搬站时间',
    offsetNo: '未搬站',
    edit: '编 辑',
    edit1: '编辑',
    tableLoading: '正在生成表格',
    operationCanceled: '操作取消',
    theme: '主题',
    networkID: '网络识别码',
    operating: '操作',
    create: '创建',
    update: '更新',
    save: '保存',
    putPointSucess: '保存成功！ 已定位测点 {located} 个，未定位测点 {unlocated} 个',
    sum: '合计',
    success: '操作成功',
    fail: '操作失败',
    collectorChannelConfig: {
      label: '通道协议',
      col1: '通道号',
      col1Pre: '通道',
      col2: '协议',
      col2Placeholder: '选择协议',
    },
    confirm: '确定',
    verificationCode: '验证码',
    user: '账号',
    password: '密码',
    confirmPassword: '确认密码',
    email: '邮箱',
    remarks: '备注',
    mobile: '手机号',
    timeBase: 'YYYY年MM月DD日 HH:mm:ss',
    tips: '提示',
    legend: '图例',
    layer: '图层',
    waitData: '等待接收数据...',

    startTest: '开始测试',
    pauseTest: '暂停测试',
    xyView: 'XY视图',
    xzView: 'XZ视图',
    yzView: 'YZ视图',
    threeDChart: '三维图',

    startVerify: '开始验证',
    pauseVerify: '暂停验证',
    deviceNodeReady: '设备各节点安装到位',
    ivt: '安装验证',
    ivtTitle: '安装反馈图',
    ivtXAxis: '安装倾斜角（度）',
    ivtYAxis: '深度（米）',
    ivtUninstall: '安装未到位',
    ivtInstalled: '安装到位',
    ivtThreshold: '安装临界值',

    readTime: '读取时间',

    originalReferencePoint: '基准点',

    remoteSensing: '遥感图',
    topographic: '地形图',
    traffic: '交通图',
    dataEmpty: '数据为空',
    projectDeviceResearch: '设备考证表',
    editThreshold: '编辑阈值',
    initCollection: '初值',
    fullscreen: '全屏',
    exitFullscreen: '退出全屏',
    waitingDev: '正在开发中，敬请期待！',
  },
  // 路由
  router: {
    Home: '首页',
    managementConsole: '管理控制台',
    projects: '项目列表',
    ProjectIndex: '项目列表',
    monitoringData: '监测数据',
    commonMonitor: '独立监测',
    groupMonitor: '组合监测',
    alarmRecord: '报警记录',
    reports: '数据报表',
    exportReport: '导出报表',
    downloadReport: '下载报表',
    projectConsole: '项目管理',
    deviceConsole: '设备管理',
    systemManagement: '系统管理',
    corporateInformation: '企业信息',
    corporationConsole: '企业信息',
    contacts: '企业联系人管理',
    config: '坐标系管理',
    corporationConsoleContacts: '企业联系人管理',
    ps: '企业简介视频',
    corporationConsolePs: '企业简介视频',
    contact: '企业联系人',
    accountManagement: '账号管理',
    userConsole: '账号管理',
    rolePermissions: '角色权限',
    roleConsole: '角色权限',
    groupManagement: '分组管理',
    userGroupConsole: '分组管理',
    collapseSidebar: '折叠侧边栏',
    profile: '个人中心',
    alerts: '报警记录',
    pushStrategy: '数据推送',
    pushStrategyConsole: '数据推送',
    CommandDebug: '命令调试',
    operationLog: '操作日志',
  },
  // 公用组件的内容
  components: {
    timingDiagram: '时序图',
    deleteObject: '删除对象',
    bimUploadStatusFinishLabel: '已上传',
    bimUploadStatusFinishLink: '发起转换',
    bimUploadStatusConvertingLabel: '正在转换',
    bimUploadStatusConvertingLink: '更新进度',
    bimUploadDeleteSourceFiles: '删除源文件',
    bimConvertSuccess: '已转换',

    imgLocationInputFromTop: '距离顶部',
    imgLocationInputFromLeft: '距离左边',
    imgLocationInputPictureAnnotation: '图片标注',
    imgLocationInputPoint: '标记点',

    locatePlaceholder: '输入地址进行定位',
    markedHere: '标注在此',

    formLabel: '关联测点',
    connected: '已关联',
    unConnected: '未关联测点',
    associatedPoint: '关联测点',
    addPoint: '添加标记',
    deletePoint: '删除标记',
    savePoint: '保存操作',

    // ConfInput组件
    confInput: {
      ids: {
      // 配置网络
        TCP: '标准网络',
        // 配置采集策略
        CommandCollect: '平台下发采集',
        UploadCollect: '设备主动上传',
        NoCollect: '停止采集',
      },
      // 配置网络
      networkConf: {
        register: '网络识别码',
      },
      // 配置采集策略
      collectConf: {
        interval: {
          label: '采集间隔',
        },
        start: '开始时间',
        end: '结束时间',
        retry: {
          label: '重试次数',
          unit: '次',
        },
        delay: {
          label: '重试间隔',
          unit: '秒',
        },
      },
    },
  },
  tableColumn: {
    bimUploadName: '文件名',
    bimUploadTranslateStatus: '转换状态(已上传/转换中/已转换)',
    time: '采集时间',
    node: '首节点',
    voltage: '电压（V）',
    temperature: '温度（°C）',
    alertTime: '报警时间',
    type: '类型',
    level: '等级',
    status: '状态',
    alarmItem: '报警项',
    alarmValue: '报警值',
    alarmReason: '报警原因',
    alarmLocation: '报警定位',
    reportTime: '报表时间',
    name: '名称',
    alertType: '报警类型',
    structureId: '关注结构物',
    alertLevel: '报警等级',
    mobileList: '短信列表',
    mobileConfirmList: '险情确认短信列表',
    mobileVoiceListField: '语音提醒列表',
    emailList: '邮箱列表',
    enable: '启用状态',
    memberName: '帐号',
    displayName: '昵称',
    memberStatus: '活动状态',
    card: '设备配置',
    card3: '位置信息',
    card4: '搬站迁移',
    card5: '坐标系配置',
    manufacturer: '制造商',
    deviceName: '设备名称',
    deviceModel: '设备型号',
    serialNumber: '序列号',
    fileName: '观测数据文件名',
    fileSize: '数据文件大小',
    fileLastTime: '观测数据文件更新时间',
    isMounted: '关联状态',
    card2: '通道配置',
    accType: '帐号类型',
    roleName: '角色名称',
    roleNote: '角色描述',
    groupName: '分组名称',
    groupNote: '分组描述',
    pushType: '推送策略',
    pushEnable: '推送开关',
    pushInterval: '推送间隔',
    ruleNote: '规则描述',
    pushUrl: '推送接口',
    jobName: '任务名称',
    jobOptions: '任务参数',
    jobNextRunAt: '预计执行时间',
    userRole: '账号角色',
    config: '配置',
    xOffset: '横向位移X',
    yOffset: '横向位移Y',
    zOffset: '纵向位移Z',
    hConvergence: '横向收敛',
    vConvergence: '纵向收敛',
    archSettlement: '拱顶沉降',
    roadbedSettlement: '道床沉降',
    differentialSettlement: '差异沉降',
    chord: '弦长',
    chordDiff: '弦长变化',
  },
  // 表单相关标签/placeholder/options
  form: {
    structureName: '结构物名称',
    structureAddress: '结构物地址',
    displayMode: '展示方式',
    structurePicture: '结构物图片',
    displayTypeOptions: {
      MAP: '地图展示',
      IMG: '图文展示',
      BIM: 'BIM模型展示',
    },
    measurementPointType: '测点类型',
    measuringPointNumber: '测点编号',
    measuringPointImage: '测点图片',
    monitoringEquipment: '监测设备',
    collectionEquipment: '采集设备',
    transmissionDevice: '传输设备',
    collectMode: '采集方式',
    uploadCollect: '数据上传',
    commandCollect: '平台下发采集',
    noCollect: '数据直通，无需采集（适用于视频监控）',
    selectTestType: '选择测试类型',
    testOptions: {
      'adm-test': '阵列位移计测试',
      'adm-install-test': '阵列位移计下压安装测试',
      'sdm-test': '倾角测试',
      'sdmx-test': '振动测试',
      'sdmpro-test': '倾角振动测试',
      'gps-sdmpro-test': '单点姿态定位测试',
    },

    pointPlaceholder: '输入测点',
    pointProject: '输入项目',
    timeLimit: '时间范围',
    intervals: '时间间隔',
    measurementType: '测值类型', // TODO
    measurementTypeOptions: {
      observations: '观测值',
      changeValue: '变化值',
    },
    gnssType: '结果类型', // TODO
    gnssTypeOptions: {
      GNSS: 'GNSS',
      GNSS2: 'GNSS2',
      GNSS3: 'GNSS3',
      GNSS4: 'GNSS4',
      GNSS5: 'GNSS5',
    },
    ObField: '观测属性',
    ObNode: '观测节点',
    pointNumber: '测点编号', // TODO
    enterpriseID: '企业ID',
    deviceType: '设备类型',
    manufacturer: '制造商',
    deviceName: '设备名称',
    deviceModel: '设备型号',
    serialNumber: '序列号',
    isSensor: '传感器（探头、棱镜）',
    withAcquisitionFunction: '具备采集功能',
    withTransmissionFunction: '具备传输功能',
    numberOfChannels: '通道数',
    networkConfiguration: '网络配置',
    collectorType: '采集器类型',
    companyName: '企业名称',
    companyNamePlacecholder: '请输入企业名称',
    logo: '企业Logo',
    favicon: '网页图标',
    platformName: '平台名称',
    platformNamePlacecholder: '请输入平台名称',
    address: '地址',
    addressPlacecholder: '请输入地址',
    slogan: '标语',
    sloganPlacecholder: '请输入标语',
    domainName: '域名',
    domainNamePlacecholder: '请输入域名',
    copyrightInformation: '版权信息',
    copyrightInformationPlacecholder: '请输入版权信息',
    loginPageBackground: '登录页背景',
    WechatAppletLoginPageBackground: '小程序登录页背景',
    WechatAppletBasePageBackground: '小程序首页图片',
    WechatAppletAboutIntroduce: '小程序关于我们介绍',
    WechatAppletContacts: '小程序联系人',
    WechatAppletContactsPhone: '小程序联系人电话',
    WechatAppletContactsMailbox: '小程序联系人邮箱',
    remarkInformation: '备注信息',
    displayName: '昵称',
    roles: '分配角色',
    userGroups: '加入分组',
    rolePlacecholder: '请选择角色',
    groupPlaceholder: '请选择分组',
    contactName: '请输入联系人姓名',
    contactsName: '联系人姓名',
    contactPhone: '请输入联系人手机号',
    contactsPhone: '联系人手机号',
    activeStatusOptions: {
      true: '禁用',
      false: '活动',
    },
    groupName: '分组名称',
    groupNote: '分组描述',
    groupRoles: '分配角色',
    groupUsers: '添加成员',
    rolesPlaceholder: '请选择角色',
    usersPlaceholder: '请选择分组成员',
    avatar: '头像',
    namePlacecholder: '请输入账号',
    displayNamePlacecholder: '请输入昵称',
    mobilePlacecholder: '请输入手机号码',
    emailPlacecholder: '请输入邮箱',
    oldPassword: '原始密码',
    newPassword: '新密码',
    newPasswordConfirmation: '确认新密码',
    oldPasswordPlaceholder: '请输入原密码',
    newPasswordPlaceholder: '请输入新密码',
    confirmationPlaceholder: '请再次输入新密码',
    pushtype: '推送类型',
    pushurl: '推送接口',
    pushinterval: '推送间隔',
    pushenable: '策略开关',
    pushdes: '规则描述',
    pushmeasuringPointIds: '测点列表',
    badNodes: '故障节点',
    hiddenNodes: '隐藏节点',
    antiSettle: '下沉修正',
    isIndep: '独立坐标',
    coorSystem: '坐标标签',
    profileChart1LMetric: '剖面图左图横轴指向',
    profileChart1RMetric: '剖面图右图横轴指向',
    profileChart1LNoteL: '剖面图左图左区备注',
    profileChart1LNoteR: '剖面图左图右区备注',
    profileChart1RNoteL: '剖面图右图左区备注',
    profileChart1RNoteR: '剖面图右图右区备注',
    profileChart3CoorSystem: '轨迹图坐标系',
    handCoorSystemOptionsR: '右手坐标系',
    handCoorSystemOptionsL: '左手坐标系',
    profileChart3NoteL: '轨迹图左区备注',
    profileChart3NoteR: '轨迹图右区备注',
    formulaType: '公式类型',
    formulaTypeSystem: '系统公式',
    formulaTypeCustom: '自定义',
    sysFormula: '选择公式',
    insideDiameter: '内径',
    insideDiameterP: '请输入测斜管内直径，单位毫米',
    selectMeasuringPoint: '选择测点',
    slaveMeasuringPoint: '子测点',
    rdmTime: '测量时间',
    rdmFixOptions: {
      unfix: '矫正前',
      fix: '矫正后',
    },
    pointPosition: '断面点位',
    sectionChord: '断面弦长',
  },
  formRules: {
    name: '姓名',
    stringRequire: '不能为空，请输入',
    arrayRequire: '不能为空，请选择',
    numberRequire: '不能为空，请输入数值',
    numberMin1Max50Require: '最小值为1，最大值为50，请输入数值',
    numberMin0Max500Require: '最小值大于0，最大值为500，请输入数值',
    length6to20: '请限制在6至20个字符以内',
    length20: '请限制在20个字符以内',
    length50: '请限制在50个字符以内',
    mobileRequire: '手机号不能为空',
    mobile: '手机格式不正确',
    email: '邮箱格式不正确',
    passwordRequire: '密码不能为空',
    passwordLength6: '密码长度不能低于6位',
    domainRequire: '企业前缀不能为空',
    contactName: '联系人姓名不能为空',
    domain: '企业前缀格式不正确,只能为字母和数字，首位为字母，长度2到9位',
    domain2: '企业前缀格式不正确,只能为字母和数字，长度2到9位',
    ip: 'IP地址格式不正确',
    point: '挂载点不能为空',
    collectorChannel: '采集通道参数格式错误',
    corporationName: '企业名称不能为空',
    corporationTitle: '云平台标题不能为空',
    userGroupName: '分组名称不能为空',
    roleRuleName: '角色名称不能为空',
    projectName: '项目名称不能为空',
    subsidiaryName: '子公司名称不能为空',
    fatherId: '请选择上级公司',
    projectAddress: '请输入项目地址',
    subsidiaryAddress: '请输入子公司地址',
    deviceMeasurement: '测量类型不能为空',
    deviceCategory: '设备类别不能为空',
    deviceType: '设备类型不能为空',
    deviceManufacturer: '制造商不能为空',
    deviceName: '设备名称不能为空',
    deviceModel: '设备型号不能为空',
    deviceModelPreg: '设备型号：',
    deviceSncode: '序列号不能为空',
    deviceCollectorType: '采集器类型不能为空',
    deviceCoorSystem: '请选择坐标标签',
    deviceProfileChart1LMetric: '请选择指向',
    deviceProfileChart1RMetric: '请选择指向',
    zrzybIp: 'IP不能为空',
    zrzybPort: '端口号不能为空',
    zrzybDeviceId: 'MQTT用户名不能为空',
    zrzybDeviceKey: 'MQTT密码不能为空',
    zrzybTopic: '设备主题Topic不能为空',
    zrzybDeviceNumber: '监测序号不能为空',
    zrzybDeviceNumberNode: '该设备监测序号数量与节点数量不一致，请核对',
    zrzybDeviceNumberNull: '监测序号不能为空或重复，请核对',
    zrzybIsPush: '请选择是否开启推送',
    deviceTypeRule: '请选择设备类别',
    mpAttrType: '请选择指标',
    mpAttrName: '指标别名不能为空',
    mpAttrDeviceId: '关联设备不能为空',
    mpAttrInterval: '测量间隔不能为空',
    mpName: '测点名称不能为空',
    mpStructureId: '请选择结构物',
    mpsId: '请选择测点',
    mpMeasuringDeviceId: '请选择测量设备',
    mpDtuId: '请关联传输设备',
    structureName: '结构物名称不能为空',
    structureType: '结构物类型不能为空',
    bimName: 'BIM模型名称不能为空',
    bimAddress: 'BIM模型地址不能为空',
    measurement: '请选择监测类型',
    formulaType: '请选择公式类型',
    computedField: '请选择转换属性',
    formula: '公式不能为空',
    sysFormula: '系统公式不能为空',
    thresholdRule: '阈值区间格式错误',
    thresholdField: '请选择监测属性',
    thresholdType: '请选择测值类型',
    thresholdVoltage: '请输入电压阈值',
    thresholdLost: '请输入丢失容限',
    alertRuleType: '请选择报警类型',
    alertRuleMobileList: '短信列表中有不规则手机号',
    alertRuleEmailList: '邮件列表中有不规则邮箱',
    projectId: '请选择项目',
    pushStrategyType: '请选择推送类型',
    pushStrategyUrl: '请填写推送接口',
    pushStrategyInterval: '请选择推送间隔',
    measuringPointIds: '请选择测点',

    structureGnsstaskName: '请输入解算任务名',
    structureGnssBaseStation: '请选择基准站',
    structureGnssBaseType: '请选择基准站类型',
    structureGnssFilteringTime: '请输入滤波时长',
    structureGnssFtTiNoZero: '滤波时长及任务间隔不能为0',
    structureGnssTaskInterval: '请输入解算任务间隔',
    structureGnssAgreementCode: '请选择设备接入协议',
    structureSwitch: '切换结构物',
    pointFilter: '过滤测点',
    sncodeExist1: '序列号 ',
    sncodeExist2: ' 已被使用，如有疑问请联系管理员',
    registerExist1: '网络识别码 ',
    registerExist2: ' 已被占用，如有疑问请联系管理员',
  },

  msg: {
    1: '是否把 {time} 采集的数据作为当前测点的初始值？',
    2: '是否删除 {time} 采集的数据？',
    3: '该操作将把此次报警状态更新为 "{status}" 且不能再更改，请确认？',

    4: '此操作将永久删除该策略, 是否继续?',
    5: '已取消删除',
    6: '是否确定修改该策略?',
    7: '已取消修改',

    8: '电压阈值，设备电压低于设置值将触发设备健康报警（欠压）',
    9: '丢失容限，连续出现设置次数的采集丢失将触发设备健康报警（采集异常）',
    10: '取消已挂起的命令任务 {name} ？',
    11: '成功更新 {count} 个监测设备的测值公式',
    12: '轨迹更新',
    13: '是否确定开启监控？',
    14: '是否确定关闭监控？',
    50: '确认删除此解算任务？',
    title1: '操作提示',
    msg1: '保存测点标记操作',
    associatedMeasuringPoint: '存在未关联测点的标记，请全部关联',
    createThresholdSucess: '成功创建 {createCount} 个测量字段阈值配置，更新 {updateCount} 个测量字段阈值配置',
    bimUpload1: '将文件拖到此处，或',
    bimUpload2: '点击上传',
    bimUpload3: '支持文件格式rvt、rfa、dwg、dxf、skp、ifc、dgn、obj、stl、3ds、dae、ply、igms、zip、fbx、dwf、nwd、osgbzip，大小限制10240M',
    bimUpload4: '请确认删除BIM模型！',
    bimUpload5: '上传源文件失败',
    bimUpload6: '源文件上传失败',
    repeatPhone: '手机号已存在',
  },
  error: {
    2: '当前测点关联的阵列位移计未更新节点号',
    4: '当前公式包含非法输入，请按提示输入',
    5: '当前公式不完整...',
    6: '测点关联监测设备类别不正确',
    7: '加载结构物选项失败',
    8: '加载监测类型选项失败',
    9: '加载设备类别失败',
    10: '加载监测字段失败',
    11: '加载测点选项失败',
    12: '成功更新 {count} 个监测设备的健康阈值',
    13: '请上传图片文件!',
    14: '上传图片大小不能超过 200KB!',
    15: '测点信息错误，无法获取测点轨迹',
    lessPointToast: '至少选择一个测点查询',
    noMeasuringDevice: '请规范操作，重新查询或刷新页面',
    noInitCollection: '设备未设置初值',
    noCollections: '当前时间范围内没有采集数据',
    rdmNoConfig: '测斜仪配置信息不完整，请先进行参数配置',
    noEqualToExpectedNodeCount: '设备节点数 ({nodeCount}) 不等于期望节点数 ({expectedNodeCount}) ，请检查设备后重排节点',
    deviceDisConnect: '请在设备联网后进行操作',
    gnssBaseStationNoData: 'GNSS基准站无监测数据',
    sgbjStr: '请填写报警内容',
    sgbjInterval: '请填写发送频率',
    sgbjTime: '请填写时间',
  },
  // 监测属性
  fields: {
    voltage: '电压',
    temperature: '温度',
    x: 'X坐标',
    y: 'Y坐标',
    z: 'Z坐标',
    azi: 'Azi',
    xyDisplacement: '平面位移量',
    xyDisplacement2: '平面距离',
    xyzDisplacement: '三维位移量',
    xyzDisplacement2: '三维距离',
    gx: 'X加速度',
    gy: 'Y加速度',
    gz: 'Z加速度',
    anglex: 'X角度',
    angley: 'Y角度',
    anglez: 'Z角度',
    angleh: '水平角',
    anglev: '垂直角',
    slantdist: '斜距',
    tiltx: 'X倾斜',
    tilty: 'Y倾斜',
    e: '东向坐标',
    n: '北向坐标',
    u: '天向坐标',
    ve: '东向坐标日变形速率',
    arctanE: '东向坐标切向角',
    vn: '北向坐标日变形速率',
    arctanN: '北向坐标切向角',
    vu: '天向坐标日变形速率',
    ven: '平面日变形速率',
    venu: '三维日变形速率',
    arctanU: '天向坐标切向角',
    differenceAge: '差分期龄',
    idmD: '水平位移', // 图像位移测量仪属性
    idmS: '沉降',
    f: '频率',
    t: '温度',
    i: '电流',
    liquidlevel: '液位值',
    deltah: '液位变化量',
    settle: '沉降量',
    displacement: '位移',
    mod: '频模',
    pressure: '渗压',
    waterlevel: '水位',
    waterlevel1: '水位',
    crack: '裂缝',
    humidy: '湿度',
    steel: '应力', // 钢筋计
    strain: '应变',
    stress: '应力', // 应变计应力
    custom: '自定义',
    dataLost: '数据丢失',
    dataRepeat: '数据重复',
    lowVoltage: '欠压',
    axialforce: '载荷力',
    soilpressure: '土压应力',
    pt: '累计降雨量（探头值）',
    pd: '日降雨量',
    pj: '当前降雨量',
    ph: '小时降雨量',
    p24: '前0~24小时雨量',
    p48: '前24~48小时雨量',
    p72: '前48~72小时雨量',
    pc: '前3天降雨量',
    pcc: '前0~24时雨量值*1+前24~48时雨量值*0.8+前48~72时雨量值*0.5',
    rainfall: '累计降雨量',
    winPressure: '气压',
    windDir: '风向',
    windSpeed: '风速',
    flowrate: '流速',
    depth: '深度',
    a: 'A',
    a0: 'A0',
    a180: 'A180',
    b: 'B',
    b0: 'B0',
    b180: 'B180',
    angle: '扭角',
    angle0: '0回次扭角',
    angle180: '180回次扭角',
    xOffset: '水平位移x',
    yOffset: '水平位移y',
    zOffset: '纵向位移Z',
    hConvergence: '横向收敛',
    vConvergence: '纵向收敛',
    archSettlement: '拱顶沉降',
    roadbedSettlement: '道床沉降',
    differentialSettlement: '差异沉降',
    chord: '弦长',
    chordDiff: '弦长变化',
  },
  // 单位
  units: {
    v: 'V',
    times: '次',
    m: 'm',
    mm: 'mm',
    frequency: '次',
    hour: '小时',
    minute: '分钟',
    second: '秒',
    deg: '度',
  },
  // 动态参数集合
  dync: {
    accType: {
      System: '系统账号',
      Admin: '企业账号',
      Normal: '普通账号',
    },
    chartType: {
      overview: '最新状态',
      'adm-chart': '数据图表',
      'tdm-chart': '数据图表',
      'common-chart': '数据图表',
      'gnss-realtime-chart': 'GNSS实时数据图表',
      'gnss-chart': '数据图表',
      'adm-data': '数据表格',
      'common-data': '数据表格',
      camera: '监控画面',
      sgbj: '声光报警',
      deviceTrajectory: '设备轨迹',
      SectionOffset: '断面位移',
      SectionConvergence: '断面收敛',
      SectionSettlement: '断面沉降',
      SectionChord: '任意弦长',
    },
    chartTypeOptions: {
      profile: '剖面图',
      componentMap: '分量图',
      orientationMap: '方位图',
      ThreeDimensionalMap: '三维图',
      horizontalChart: '水平沉降图',
      circularChart: '设备环形图',
      rdmPipeChart: '本次管型图',
      rdmChangeChart: '本次变化图',
      rdmAccChangeChart: '累计变化图',
      rdmFixRChart: '本次扭角图',
      rdmTempChart: '本次温度图',
    },
    devicetype: {
      Measuring: '测量设备',
      Collector: '采集设备',
      DTU: '传输设备',
    },
    collectorType: {
      ADM: '华思ADM采集器',
      HDA2: '华思振弦式数采',
      HDA3: '华思电流式数采',
      SDM: '华思点式数采',
    },
    structureType: {
      Bridge: '桥梁',
      FoundationPit: '基坑',
      Slope: '边坡',
      Dam: '大坝',
      Tunnel: '隧道',
      Tailings: '尾矿库',
      Building: '建筑物',
      Tower: '铁塔',
      SpecialEquipment: '特种设备',
      WeatherStation: '气象站',
      PipeNetwork: '市政管网',
    },
    measuringType: {
      ALL: '全部',
      DeepDisplacement: '深部位移',
      SurfaceDisplacement: '表面位移',
      Waterlevel: '水位',
      Waterlevel1: '水位',
      Tilt: '倾斜',
      Vibration: '振动',
      Crack: '裂缝',
      Track: '轨迹',
      DBCJ: '地表沉降',
      ZCYL: '应力应变',
      AxialForce: '轴力监测',
      StructuralDeformation: '结构变形',
      Camera: '视频监控',
      SGBJ: '声光报警',
      Temperature: '温度',
      Rainfall: '雨量',
      Flow: '流量',
      Moisture: '湿度',
      SoilPressure: '土体压力',
      SoilMoisture: '墒情',
      Displacement: '位移',
      WindSpeed: '风速',
      WindDirection: '风向',
      SlopeVibration: '边坡振动',
      HorizontalTilt: '水平倾斜',
      SupportingStructureDeformation: '支护结构变形',
      GNSSReferenceStation: 'GNSS基准站',
      GNSSMonitoringStation: 'GNSS监测站',
      GroundwaterLevel: '地下水水位',
      PhreaticLine: '浸润线',
      ClearanceConvergence: '净空收敛',
      PoreWaterPressure: '孔隙水压',
      Deflection: '挠度',
      DebrisFlow: '泥石流',
      SupportingAxialForce: '支撑轴力',
      AnchorForce: '锚索索力',
    },
    deviceCategory: {
      ADM: '阵列位移计',
      HDA2: '振弦式渗压计',
      HDA3: '电流式水位计',
      HDA_HS: '华思水位計',
      Crack: '振弦式测缝计',
      SDM: '倾角计',
      SDMM: '倾角位移计',
      SDMX: '振动计',
      SDMPRO: '倾角振动计',
      TDM: '轨迹计',
      HSL: '静力水准仪',
      STRAIN: '振弦式应变计',
      Steel: '振弦式钢筋计',
      Anchor: '振弦式锚索计',
      AFM: '振弦式轴力计',
      SPM: '振弦式土压力计',
      SHM: '土壤湿度温度传感器',
      Station: '全站仪',
      GNSS: 'GNSS',
      Camera: '摄像头',
      SGBJ: '声光报警器',
      RDM: '测斜仪',
      IDM: '图像位移测量仪',
      Rain: '雨量计',
      Flow: '流量计',
    },
    alarmStatus: {
      Pending: '待处理', // 待处理
      Notice: '已通知', // 已通知
      Confirm: '险情确认', // 险情确认
      ConfirmNotice: '险情确认已通知', // 险情确认
      FalseAlarm: '误报', // 误报
      Restore: '恢复正常', // 恢复正常
    },
    timeOptions: {
      hour1: '最近一小时',
      day1: '最近一天',
      week1: '最近一周',
      month1: '最近一月',
      halfYear: '最近半年',
      year1: '最近一年',
      thisHour1: '最近这小时',
      thisDay1: '最近这天',
      thisWeek1: '最近这周',
      thisMonth1: '最近这月',
      thisHalfYear: '最近这半年',
      thisYear1: '最近这年',
    },
    intervalsText: {
      seconds0: '无间隔',
      seconds1: '每1秒',
      seconds5: '每5秒',
      seconds10: '每10秒',
      seconds30: '每30秒',
      minute1: '每1分钟',
      minute2: '每2分钟',
      minute5: '每5分钟',
      minute10: '每10分钟',
      minute15: '每15分钟',
      minute30: '每30分钟',
      hour1: '每1小时',
      hour2: '每2小时',
      hour6: '每6小时',
      hour12: '每12小时',
      day1: '每1天',
      day2: '每2天',
      day5: '每5天',
      day7: '每7天',
      day10: '每10天',
      day20: '每20天',
      day30: '每30天',
    },
    tScope: {
      Corporation: '企业',
      User: '账号',
      Coordinate: '坐标系',
      UserGroup: '分组',
      Role: '角色',
      Project: '项目',
      Structure: '结构物',
      MeasuringPoint: '测点',
      Device: '设备',
      Report: '报告',
      AlertRule: '报警规则',
      PushRule: '数据推送',
      Alert: '报警记录',
    },
    tAction: {
      Create: '创建',
      Delete: '删除',
      Retrieve: '查看',
      Update: '更新',
    },
    tDevType: {
      Measuring: '监测设备',
      Collector: '采集设备',
      DTU: '传输设备',
    },
  },

  // 登录页的内容
  login: {
    login: '登录',
    register: '注册',
    username: '用户名',
    zh: '简体中文',
    en: 'English',
    zhTW: '繁體中文',
    rememberMe: '记住我',
    forgetPassword: '忘记密码',
    loading: '登录中...',
    slogan: '因为专注 所以专业',
    start: '开始',
    accountInformation: '账号信息',
    companyInformation: '企业信息',
    ending: '完成',
    phone: '手机号码',
    domain: '企业前缀',
    companyName: '企业名',
    cloudPlatformTitle: '云平台标题',
    copyrightInformation: '版权信息',
    previous: '上一步',
    loginPage: '登录页面',
    backRegisterPage: '返回注册页面',
    verificationCodePlaceholder: '请输入验证码',
    verifySvgCodePlaceholder: '请输入图片验证码',
    verifyPhoneCodePlaceholder: '请输入手机验证码',
    usernamePlaceholder: '请输入用户名',
    passwordPlaceholder: '请输入密码',
    validatePasswordDifferent: '两次输入密码不一致',
    resetPsd: '重置密码',
    verify: '验证码', // TODO
    verifyPhone: '手机验证码', // TODO
    verifySvg: '图片验证码', // TODO
    usernameR: '请填写用户名',
    passwordR: '请填写密码',
    phoneR: '请填写手机号码',
    phoneR2: '请填写正确的手机号码',
    verifyR: '请填写验证码',
    formR: '请把表单填写完整后继续！',
    getVerify: '获取手机验证码',
    returnLogin: '返回登录',
    submit: '提交',

    resetSuccessTit: '重置密码成功',
    resetSuccessP: '重置密码成功，密码将会以短信形式发送到您的手机。',
  },
  // 首页
  home: {
    projectStatusStatistics: '项目状态统计',
    amount: '数目',
    structureStatus: '结构物状态统计',
    pointStatus: '测点状态统计',
    alarmProcessing: '报警处理统计',
    projectStatus: '状态',
    projectLevel: ['正常', '黄色报警', '橙色报警', '红色报警'],
    healthStatusList: ['正常', '设备欠压', '数据丢失', '数据重复'],
    healthStatus: {
      health: '正常',
      lowVoltage: '设备欠压',
      dataLost: '数据丢失',
      dataRepeat: '数据重复',
    },
    projectNoExist: '项目不存在',
    historyAlarm: '历史报警',
    projectName: '项目名称',
    projectAddress: '项目地址',
    structuresTotal: '结构物总数',
    pointTotal: '测点总数',
    associatedDeviceTotal: '关联设备总数',
    projectInfo: '项目信息', // TODO
    deviceStatus: '设备状态统计',
    monitoringOverview: '监测概况',
    alertStat: '报警状态',
    monitoringTableHeader: [
      '结构物',
      '测点',
      // '设备号',
      // '设备电压',
      '监测项',
      '最大变化',
      '累计位移',
      '日变化速率',
      '最近采集',
      '报警状态',
      '报警值',
    ],
    alarmOverview: '报警概况',
    tableHeader: ['结构物', '测点', '报警事件'],
    defaultIntroduction: '该项目还未填写备注信息，请在项目管理中填写。',
    total: '总量',
    goBack: '上一级',
  },
  // 检测数据
  monitor: {
    preview: '数据总览',
    createStructure: '请创建结构物',
    selectChartType: '选择图表类型',
    viewNode: '查看节点',
    profileChart: '剖面图',
    FIGTimingMeasuring: '测点时序图',
    timeValueChart: '观测数据过程线图',
    nodeValueChart: '节点数据过程线图',
    nodeTrackChart: '节点轨迹图',
    admPropChart: '分量图',
    horizontalChart: '水平沉降图',
    circularChart: '环形图',
    displacementChart: '变形量图',
    coordChart: '方位观测值图',
    coordChangeChart: '方位变化值图',
    vibrationChart: '振动数据过程线图',
    GNSSChart: 'GNSS数据过程线图',
    pipeChart: '管型图',
    rdmTempChart: '本次温度图',
    rdmFixrChart: '本次扭角图',
    rdmChangeChart: '本次变化图',
    rdmAccChangeChart: '累计变化图',
    initTime: '初始时间',
    initData: '初始数据',
    componentTrendGraph: '分量趋势图',
    weight: '分量',
    WarningLine: '警戒线',
    level1: '一级',
    level2: '二级',
    level3: '三级',
    takePictures: '拍照',
    playRecPlayer: '切换直播或录像',
    more: '加载更多',
    HistorySnapshot: '历史抓拍',
    RecPlayer: '录像回放',
    LivesPlayer: '视频直播',
    controlPanel: '摄像头控制面板',
    sgbjControlPanel: '声光报警控制面板',
    livePlayerLoading: '正在获取accessToken...',
    setInitValue: '设为初值',
    deleteRecord: '删除记录',
    batchDeletion: '批量删除',
    collectionDetails: '采集详情',
    time: '时间',
    node: '节点',
    elevation: '高程',
    depth: '深度',
    displacement: '位移',
    distance: '距离',
    settlement: '沉降',
    changeValue: '变化量',
    NbyE: '北偏东',
    offset: '偏移',
    A: 'A方向',
    B: 'B方向',
    E: '东向',
    N: '北向',
    NodeOrientationData: '节点方位数据',
    zoom: '显示比例',
    showSection: '显示剖面',
    ratioOptions: {
      ratio: '等比例',
      adaptive: '自适应',
    },
    profileOptions: {
      view3d: '三维视图',
      XYPlaneABPlane: 'XY 面（AB 面）',
      XZPlaneAZPlane: 'XZ 面（AZ 面）',
      YZPlaneBZPlane: 'XY 面（BZ 面）',
    },
    refreshStatus: '刷新状态',
    caustomReportColumns: '定制报告列',
    customColumn: '定制列',
    nodePlaceholder: '请选择节点',
    dialogDeleteTitle: '批量删除方式的选择',
    chooseDeleteTime: '删除的时间段选择',
    deleteCollotion: '请先选择要删除的采集数据',
    deleteByTime: '按时间段删除',
    deleteBySelection: '按选中的采集数据删除',
    chartSetting: '图表属性设置',
    xAxis: '横轴',
    yAxis: '纵轴',
    LXAxis: '左图横轴',
    RXAxis: '右图横轴',
    chartInterval: '列宽',
    max: '最大值',
    min: '最小值',
    useSetting: '应用',
    common: '其他设置',
    showSymbol: '显示标记图形',
    trendPrediction: '趋势预测',
    multiIndicatorEarlyWarning: '多指标预警',
    sgbj:{
      status:{
        waiting:'等待中',
        being:'发送中',
        finish:'完成',
        cancel:'取消',
      }
    }
  },
  // 报警记录
  alerts: {
    alarmRecord: '报警记录',
    alarmType: '报警类型', // TODO
    alarmTypeOptions: {
      measuredValueAlarm: '测值报警',
      equipmentFailure: '设备故障',
    },
    status: '状态',
    level: '报警等级',
    levelOptions: ['-', '黄色报警', '橙色报警', '红色报警'],
    alarmDetail: '报警详情',
    ConfirmationDanger: '险情确认',
    riskExclusion: '险情排除',
    alertDetail: {
      alarmID: '报警ID',
      monitoringAttr: '监测属性',
      triggerInterval: '触发区间',
      SMScontent: '短信内容',
      email: '邮件内容',
      noticeList: '通知名单',
      mailingList: '邮件名单',
      levelAlarm: '级报警',
    },
    reason: {
      dataLost: '数据丢失超过',
      lowVoltage: '电压低于',
      value: '测值落在阈值区间',
    },
  },
  // 报表下载
  report: {
    exportReport: '导出报表',
    downloadReport: '下载报表',
    reportType: '报表类型',
    reportOption: {
      exportData: '数据导出',
      measuringPointReport: '测点报告',
      projectReport: '项目报告',
      projectDeviceResearchReport: '项目设备考证表',
    },
    download: '下载',
    export: '导出',
    delete: '删除报表',
    confirmHandler: '请再次确认您的操作！',
    reportStatus: {
      Done: '完成',
      Pending: '正在生成',
      Error: '错误',
    },
    template: '报表模板',
    ts: {
      project: '项目监测报表',
      day: '结构物监测报表',
      SectionDeformation: '断面形变报表',
    },
    period: '报表时间',
  },
  // 项目管理
  project: {
    siteMonitoring: '测点监控',
    waitPicture: '项目图片待上传',
    newProject: '新建项目',
    newSubsidiary: '新建子公司',
    showSubsidiary: '查看公司组织架构',
    showSubsidiary2: '公司组织架构',
    allProject: '所有项目',
    structureType: '结构物类型',
    measurement: '监测类型',
    structureDetails: '结构物详情',
    pointDetails: '测点详情',
    projectDetails: '项目详情',
    createStructure: '创建结构物',
    createPoint: '创建测点',
    createProject: '创建项目',
    createSubsidiary: '创建子公司',
    projectInfo: '项目信息',
    subsidiaryInfo: '子公司信息',
    deviceTopology: '设备拓扑',
    convert: '测值转换',
    alarmThreshold: '报警阈值',
    equipmentHealth: '设备健康',
    alarmManagement: '报警管理',
    memberManagement: '成员管理',
    updateRecord: '更新记录',
    deleteProject: '删除项目',
    deleteTitle: '删除项目，项目下的结构物、测点、设备等数据将关联删除，请谨慎操作！',
    projectName: '项目名称',
    subsidiaryName: '子公司名称',
    fatherId: '上级公司',
    address: '项目地址',
    subsidiaryAddress: '子公司地址',
    coordinate: '经纬坐标',
    picture: '项目图片',
    pictureSubsidiary: '子公司图片',
    conversionFormulaTitle: '配置测值转换公式',
    conversionAttributes: '转换属性',
    conversionFormula: '转换公式',
    conversionFormulaPlaceholder: '请输入有效的公式',
    conversionFormulaTip: {
      show: '显示提示',
      hide: '隐藏提示',
      tip1: '请使用英文输入法。',
      tip2: {
        1: '可输入数字',
        2: '小数点',
      },
      tip3: {
        1: '可输入以下运算符：加减乘除',
        2: '括号',
        3: '平方',
        4: '开方',
        5: '正弦',
      },
      monitoringAttributes: '可使用监测属性',
      eg: '示例',
      text: '表示求监测属性{text}的平方',
    },
    appPoint: '应用测点',
    noUsePoint: '没有相关测点',
    configThreshold: '配置测点报警阈值',
    monitoringAttributes: '监测属性',
    monitoringAttributesPlaceholder: '请选择监测属性',
    measurementType: '测值类型',
    measurementTypeOptions: {
      1: '监测值',
      2: '变化值',
    },
    FirstLevelThreshold: '黄色阈值',
    thresholdPlaceholder: '请输入阈值区间',
    AddThreshold: '添加橙色阈值区间',
    secondLevelThreshold: '橙色阈值',
    deleteSecondLevelThreshold: '删除橙色阈值区间',
    addThirdThreshold: '添加红色阈值区间',
    thirdLevelThreshold: '红色阈值',
    deleteThirdLevelThreshold: '删除红色阈值区间',
    addContact: '添加联系人',
    editContact: '编辑联系人',
    delContact: '删除联系人',
    contact: '联系人',
    thresholdTip: {
      eg: '示例',
      tip1: '请使用数学区间表示',
      tip2: '请使用英文输入法',
      tip3: {
        1: '可输入数字',
        2: '小数点',
        3: '正无穷',
        4: '负无穷',
      },
      tip4: {
        1: '开区间',
        2: '闭区间',
        3: '半开闭区间',
      },
      tip5: {
        1: '多个区间用分号',
        2: '隔开',
      },
      tip6: {
        1: '表示',
        2: '或',
      },
    },
    configDeviceHealth: '配置设备健康阈值',
    monitorSwitch: '监控开关',
    voltageThreshold: '电压阈值',
    voltageThresholdPlaceholder: '请输入有效的阈值区间',
    lossTolerance: '丢失容限',
    lossTolerancePlaceholder: '请输入有效的阈值区间',
    ruleListTitle: '规则列表',
    configAlarmRule: '配置报警通知规则',
    editAlarmRules: '编辑报警通知规则',
    deleteAlarmRule: '删除报警规则',
    measuredValueAlarm: '测值类报警',
    levelPlaceholder: '请选择报警等级',
    EquipmentAlarm: '设备类报警',
    mobileListPlaceholder: '请选择用于接收报警短信的手机号，可选多个手机',
    emailListPlaceholder: '请输入用于接收报警邮件的邮箱，多个邮箱换行输入',
    GnssSolutionConfig: 'GNSS解算配置',
    ZrzybConfig: '物联网云平台配置',
    EnshiPushConfig: '恩施数据推送配置',
    YunzhiPushConfig: '成都数据推送配置',
    YichangPushConfig: '宜昌数据推送配置',
    WhdzPushConfig: '武汉地灾数据推送配置',
    HuasiPushConfig: '广州数据推送配置',
    SDMPROSolutionConfig: '倾角振动计配置',
    GnssConfig: {
      taskName: {
        label: '解算任务名',
      },
      BaseStation: {
        label: '基准站',
      },
      baseType: {
        label: '基准站类型',
      },
      FilteringTime: {
        label: '滤波时长',
        unit: '小时',
      },
      TaskInterval: {
        label: '解算任务间隔',
        unit: '分钟',
      },
      taskMode: {
        label: '解算模式',
      },
      Smooth: {
        label: '平滑',
      },
    },
    memberManagementStatusOptions: {
      true: '禁用',
      false: '活动',
    },
    updateMember: '更新项目成员',
    at: '于',
    do: '进行',
    noRecord: '暂无操作记录',
    structureInfo: '结构物信息',
    pointDistribution: '测点分布',
    deleteStructure: '删除结构物',
    deleteStructureTitle: '删除结构物，结构物下的测点数据将关联删除，请谨慎操作！',
    pointInfo: '测点信息',
    deviceInfo: '设备信息',
    deviceConfiguration: '设备配置',
    deviceTesting: '设备测试',
    deleteMeasuringPoint: '删除测点',
    deleteMeasuringPointTip: '删除测点及其关联数据，请谨慎操作！',
    dataMining: '数采',
    other: '其他',
    channel: '通道',
    deviceName: '设备名称',
    serialNumber: '序列号',
    manufacturer: '制造商',
    deviceModel: '设备型号',
    model: '型号',
    channels: '通道总数',
    occupiedChannel: '使用通道',
    networkConfiguration: '网络配置',
    register: '网络注册码',
    thresholdConfiguration: '阈值配置',
    monitoringField: '监测字段',
    dataPush: '数据推送',
    calculation: '计算方式',
    firstInterval: '黄色阈值区间',
    secondInterval: '橙色阈值区间',
    thirdInterval: '红色阈值区间',
    deleteThreshold: '删除阈值',
    listeningToData: '正在监听数据',
    clearScreen: '清屏',
    toggleEncode: '切换编码',
    queryCommands: '查询类命令',
    settingCommands: '设置类命令',
    otherCommands: '其他命令',
    operationTips: '操作提示',
    tipsThreshold: '是否删除阈值',
    collectionTime: '采集时间',
    nodeNum: '节点号',
    hangJob: '已挂起任务',
    collectConf: '采集配置',
    zrzybwlwpt: '自然资源部物联网云平台',
    enshiPush: '恩施数据推送',
    huasiPush: '广州数据推送',
    wuhanPush: '武汉地灾推送',
    yunzhiPush: '成都数据推送',
    zrzybwlwptConfig: '自然资源部物联网云平台数据推送配置',
    enshiPushConfig: '恩施数据推送配置',
    huasiPushConfig: '广州数据推送配置',
    wuhanPushConfig: '武汉地灾数据推送配置',
    yunzhiPushConfig: '成都数据推送配置',
    yichangPushConfig: '宜昌数据推送配置',
    processorConf: '数据处理',
    formulaConf: '公式配置',
    chartConf: '图表配置',
    addSlavePoint: '添加子测点',
    removeSlavePoint: '删除子测点',
    createCommonPoint: '创建普通测点',
    createCompositePoint: '创建组合测点',
    contingencyPlan: '应急预案',
  },
  // 设备中心
  device: {
    equipmentCenter: '设备中心',
    addDevice: '添加设备',
    editDevice: '编辑设备',
    measuringEquipment: '测量设备',
    collectionEquipment: '采集设备',
    transmissionDevice: '传输设备',
    inputPlaceholder: '过滤名称、序列号、型号',
    measurementPlaceholder: '过滤监测类型',
    categoryPlaceholder: '过滤设备类别',
    filterSensor: '只看传感器',
    isMountedOptions: {
      true: '已关联',
      false: '未关联',
    },
    deleteDevice: '删除设备',
    noConfiguration: '当前设备无须配置',
    DeviceConfiguration: {
      nodes: '节点号',
      segmentLen: '节点间距',
      initTwist: '初始偏移角',
      markAngle: '北偏转角',
      chartDirection: '图表纵轴',
      chartDirectionDown: '向下为正（深埋安装）',
      chartDirectionUp: '向上为正（地上安装）',
      elevation: '高程',
      version: '固件版本',
      zrzybIp: 'HTTP IP',
      zrzybPort: 'HTTP 端口号',
      zrzybApi: 'HTTP拓展接口(非必填)',
      zrzybMqttIp: 'MQTT IP',
      zrzybMqttPort: 'MQTT 端口号',
      zrzybDeviceId: 'MQTT用户名',
      zrzybMQCID: 'MQTT clientId',
      zrzybDevice: '设备号',
      zrzybDeviceKey: 'MQTT密码',
      zrzybTopic: '设备主题Topic',
      zrzybDeviceNumber: '监测序号',
      zrzybIsPush: '开启推送',
      yunzhiMqttInterval: '推送间隔',
      zrzybMsg: '如多个序号，请用英文逗号分隔，示例: 100001,100002,100003',
      // baseStationAgreementCode: '基准站设备接入协议',
      // baseStationIP: '基准站IP',
      // baseStationPort: '基准站端口号',
      // baseStationPoint: '基准站挂载点',
      // baseStationUsername: '基准站挂载用户名',
      // baseStationPassword: '基准站挂载密码',
      // baseStationX: '基准站X方向概略坐标',
      // baseStationY: '基准站Y方向概略坐标',
      // baseStationZ: '基准站Z方向概略坐标',
      // baseStationNTRIPLng: '基准站NTRIP经度',
      // baseStationNTRIPLat: '基准站NTRIP纬度',
      // baseStationNTRIPHeight: '基准站NTRIP高度',
      agreementCode: '设备接入协议',
      port: '端口号',
      point: '挂载点',
      username: '挂载用户名',
      password: '挂载密码',
      gnssX: 'X方向概略坐标',
      gnssY: 'Y方向概略坐标',
      gnssZ: 'Z方向概略坐标',
      NTRIPLng: 'NTRIP经度',
      NTRIPLat: 'NTRIP纬度',
      NTRIPHeight: 'NTRIP高度',
      deviceSerial: '海康序列号',
      validateCode: '验证码',
      K: '灵敏度系数K',
      Kt: '温度系数Kt',
      f0: '初始频率f0',
      t0: '初始温度t0',
      Kr: '雨量计系数Kr',
      iMin: '最小电流',
      iMax: '最大电流',
      fullscale: '量程',
      maxDepth: '最大深度',
      minDepth: '最小深度',
      nodeCount: '节点总数',
      mqttKey: 'MQTT-设备Key',
      deviceId: 'MQTT-设备ID',
    },
    log: {
      span1: '修改了',
      span2: '为',
    },
    bulkAddDevice: '批量导入设备',
    upload1: '选择文件',
    upload2: '点击下载',
    upload3: '模板文件.xlsx',
    upload4: '只能上传 <模板文件.xlsx>，且不超过2MB',
    upload5: '选择文件后继续',
    deviceNum: '导入设备数：',
    failRow: '失败行：',
  },
  // 设置
  setting: {
    updateCompleted: '更新成功',
    createAccount: '创建账号',
    editAccount: '编辑账号',
    deleteAccount: '删除账户',
    deleteCoordinate: '删除坐标系',
    initCoordinate: '重置坐标系',
    roleTitle: '角色权限管理',
    creatingRole: '创建角色',
    deleteRole: '删除角色',
    editRole: '编辑角色',
    assignPermissions: '分配权限',
    accountGroup: '账号分组',
    createGroup: '创建分组',
    editGroup: '编辑分组',
    deleteGroup: '删除分组',
  },
  // 个人中心
  profile: {
    baseInfo: '基本信息',
    changePassword: '修改密码',
    updateCompleted: '更新成功',
  },
  // 推送策略
  pushStrategy: {
    add: '创建策略',
    update: '修改策略',
    pushRuleTypes: {
      PushAdmACC: '推送加速度',
      PushAdmXYZ: '推送坐标观测值',
      PushAdmXYZChange: '推送坐标变化值',
      PushAdmEN: '推送东北方位角',
      PushGlodonValue: 'Glodon格式推送（测试）',
    },
    timeOptions: {
      300000: '5分钟',
      600000: '10分钟',
      1800000: '30分钟',
      3600000: '1小时',
      7200000: '2小时',
    },
  },
  operationLog: {
    key: '关键词',
    keyP: '请输入IP / UA',
    scope: '模块',
    scopeP: '请选择模块',
    action: '操作',
    actionP: '请选择操作',
    scopeId: '模块ID',
    ip: 'IP',
    ua: '客户端',
    content: '操作内容',
  },
  protocols: {
    ADM: 'HS-ADM',
    HDA2: 'HS-HDA（频率数据）',
    HDA3: 'HS-HDA（电流数据）',
    HDA_HSL: 'HS-HDA（静力水准）',
    HDA_FLOW: 'HS-HDA（流速数据）',
    HDA_RAIN: 'HS-HDA（雨量数据）',
    SDM: 'HS-SDM（倾角振动数据）',
    GDM: 'HS-GDM（GNSS数据）',
    ROCTEC_ADM: '接入岩石科技（ADM）',
    ROCTEC_HYDRO: '接入岩石科技（静力水准仪）',
    ROCTEC_STATION: '接入岩石科技（全站仪）',
    ROCTEC_ZCYL: '接入岩石科技（支撑应力）',
    WHU_GNSS: '接入武大GNSS',
    HSAPP_RDM: '接入测斜仪APP',
    TGY_IDM: '接入同感云（图像位移）',
    HYDRO: '接入水文数据',
    OTHER: '其他协议（空协议）',
  },
};
